import React, { useEffect, useMemo, useState } from 'react';
import {
  getDownloadURL,
  listAll,
  ref,
  uploadBytesResumable,
} from 'firebase/storage';
import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { db, storage } from '../firebaseConfig';

const AULAS_CONFIG = {
  'aula-1': {
    titulo: 'Aula 1 - Introdução',
    descricao: 'Conteúdo inicial da aula 1.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/go6VY4JYj30?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 1',
      descricao:
        'Observe cada objeto e construa por cima dele uma estrutura em forma de cubo, respeitando os limites que ele ocupa no espaço. Mesmo que o objeto seja arredondado, oval ou irregular, você deve encaixá-lo dentro de um cubo, entendendo o volume total que ele ocupa. Use as imagens como referência visual e faça exatamente como está demonstrado na referência abaixo.',
      imagens: ['4.jpeg', '1.jpeg', '2.jpeg', '3.jpeg'],
    },
    prova: {
      titulo: 'Prova da Aula 1',
      descricao:
        'Tire fotos de 3 objetos simples do seu dia a dia. Para cada objeto fotografado, construa somente o cubo que o contém, respeitando seus limites no espaço.\n\nAlém disso, em cada estudo, identifique visualmente:\n1. Altura\n2. Largura\n3. Profundidade\n\nNão é necessário desenhar os detalhes internos do objeto. O foco da prova é mostrar se você compreendeu como observar o volume total que o objeto ocupa e como encaixá-lo corretamente dentro de um cubo.\n\nImportante:\n1. Faça a estrutura de forma limpa.\n2. Respeite os limites reais do objeto.\n3. Defina altura, largura e profundidade de cada um.\n4. Use como referência o mesmo raciocínio mostrado nos exercícios.',
      imagens: [],
    },
  },
  'aula-2': {
    titulo: 'Aula 2',
    descricao: 'Videoaula da aula 2.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/HGbRvK_n0Y4?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 2',
      descricao: 'TRANSFORMAR BLOCOS EM OBJETOS',
      imagens: ['exercicio1aula2.png', 'exercicio2aula2.png', 'exercicio3aula2.png'],
    },
    prova: {
      titulo: 'Prova da Aula 2',
      imagens: ['prova2.png'],
    },
  },
  'aula-3': {
    titulo: 'Aula 3',
    descricao: 'Terceira aula.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/vMqo4XmR1VA?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 3',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 3',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-4': {
titulo: 'Aula 4 - Complemento',
    descricao: 'Quarta aula.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/AcaxupM8tL8?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 4',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: ['exercicio1aula34.jpeg'],
    },
    prova: {
      titulo: 'Prova da Aula 4',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-5': {
    titulo: 'Aula 5',
    descricao: 'Quinta Aula',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/Pqb_9ts21d4?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 5',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: ['exercicioaula5.jpeg'],
    },
    prova: {
      titulo: 'Prova da Aula 5',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-6': {
    titulo: 'Aula 6',
    descricao: 'Sexta aula.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/gk91h3vpsOo?rel=0',
exercicios: {
  titulo: 'Exercícios da Aula 6',
  descricao: 'Faça o exercício usando a referência abaixo.',
  imagens: ['exercicioaula6.png'],
},
    prova: {
      titulo: 'Prova da Aula 6',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-7': {
    titulo: 'Aula 7',
    descricao: 'Sétima aula.',
    vimeoEmbedUrl: 'https://www.youtube.com/embed/S125hWEOThs?rel=0',
    exercicios: {
      titulo: 'Exercícios da Aula 7',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 7',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-8': {
    titulo: 'Aula 8',
    descricao: 'Conteúdo da aula 8 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 8',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 8',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-9': {
    titulo: 'Aula 9',
    descricao: 'Conteúdo da aula 9 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 9',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 9',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-10': {
    titulo: 'Aula 10',
    descricao: 'Conteúdo da aula 10 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 10',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 10',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-11': {
    titulo: 'Aula 11',
    descricao: 'Conteúdo da aula 11 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 11',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 11',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-12': {
    titulo: 'Aula 12',
    descricao: 'Conteúdo da aula 12 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 12',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 12',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-13': {
    titulo: 'Aula 13',
    descricao: 'Conteúdo da aula 13 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 13',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 13',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
  'aula-14': {
    titulo: 'Aula 14',
    descricao: 'Conteúdo da aula 14 ainda não configurado.',
    vimeoEmbedUrl: '',
    exercicios: {
      titulo: 'Exercícios da Aula 14',
      descricao: 'Exercícios ainda não cadastrados para esta aula.',
      imagens: [],
    },
    prova: {
      titulo: 'Prova da Aula 14',
      descricao: 'Prova ainda não cadastrada para esta aula.',
      imagens: [],
    },
  },
};

const PROFESSOR_EMAIL = 'rodrigorasilva@hotmail.com';

const mergeLessonContent = (baseLesson, remoteLesson) => {
  if (!baseLesson) return null;
  if (!remoteLesson) return baseLesson;

  return {
    ...baseLesson,
    descricao: remoteLesson.descricao ?? baseLesson.descricao,
    vimeoEmbedUrl: remoteLesson.vimeoEmbedUrl || baseLesson.vimeoEmbedUrl || '',
    exercicios: {
      ...(baseLesson.exercicios || {}),
      ...(remoteLesson.exercicios || {}),
      imagens: [
        ...((baseLesson.exercicios?.imagens || [])),
        ...((remoteLesson.exercicios?.imagens || [])),
      ],
    },
    prova: {
      ...(baseLesson.prova || {}),
      ...(remoteLesson.prova || {}),
      imagens: [
        ...((baseLesson.prova?.imagens || [])),
        ...((remoteLesson.prova?.imagens || [])),
      ],
    },
  };
};

const isHttpUrl = (value = '') => {
  return /^https?:\/\//i.test(value);
};



const injectedStyles = `
  html, body, #root {
    background: #0d0d0d;
    color: #fff;
    overflow-x: hidden;
  }

  .container2.home-shell,
  .container.home-container,
  .aula-screen-box {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    background:
      radial-gradient(circle at top, rgba(255,255,255,0.04), transparent 30%),
      linear-gradient(180deg, #0d0d0d 0%, #131313 100%);
    color: #fff;
    overflow-x: hidden;
  }

  .aula-screen-topbar {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 16px;
  }

  .btn.btn-outline,
  .btn.btn-primary {
    border: 0;
    outline: 0;
    cursor: pointer;
    border-radius: 14px;
    padding: 12px 16px;
    font-weight: 800;
    transition: transform .18s ease, opacity .18s ease, box-shadow .18s ease;
  }

  .btn.btn-outline {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.14);
    color: #fff;
    box-shadow: 0 10px 30px rgba(0,0,0,0.20);
  }

  .btn.btn-primary {
    background: linear-gradient(135deg, #ff5b5b 0%, #d93a3a 100%);
    color: #fff;
    box-shadow: 0 14px 40px rgba(255,91,91,0.20);
  }

  .video-card.video-card-expanded,
  .aula-extra-card {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.10);
    border-radius: 26px;
    box-shadow: 0 18px 60px rgba(0,0,0,0.30);
    backdrop-filter: blur(10px);
  }

  .video-card.video-card-expanded {
    padding: 18px;
    margin-bottom: 18px;
  }

  .video-placeholder {
    min-height: 280px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 22px;
    background: rgba(255,255,255,0.04);
    color: rgba(255,255,255,0.72);
    text-align: center;
    padding: 24px;
  }

  .vimeo-embed-wrap.vimeo-embed-wrap-tall {
    position: relative;
    border-radius: 22px;
    overflow: hidden;
    background: #090909;
    border: 1px solid rgba(255,255,255,0.06);
  }

  .lesson-iframe {
    aspect-ratio: 16 / 9;
    min-height: 240px;
    background: #000;
  }

  .lesson-iframe.lesson-iframe-locked {
    filter: blur(6px);
    pointer-events: none;
  }

  .video-protect-overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(0,0,0,0.52);
  }

  .video-protect-box {
    width: 100%;
    max-width: 420px;
    text-align: center;
    padding: 24px;
    border-radius: 24px;
    background: rgba(12,12,12,0.92);
    border: 1px solid rgba(255,255,255,0.10);
    box-shadow: 0 20px 60px rgba(0,0,0,0.35);
  }

  .video-protect-badge,
  .aula-extra-toggle span:first-child,
  .aula-extra-toggle-static span:first-child,
  .uploaded-files-title {
    letter-spacing: 0.06em;
  }

  .video-protect-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 999px;
    background: rgba(255,91,91,0.12);
    border: 1px solid rgba(255,91,91,0.24);
    color: #ff7b7b;
    font-size: 0.78rem;
    font-weight: 900;
    margin-bottom: 14px;
  }

  .video-protect-title,
  .aula-extra-title,
  .uploaded-files-title {
    color: #fff;
    margin: 0 0 10px;
  }

  .video-protect-text,
  .aula-extra-text,
  .aula-extra-helper,
  .upload-message {
    color: rgba(255,255,255,0.78);
  }

  .aula-extra-sections {
    margin-top: 4px;
  }

  .aula-extra-card {
    overflow: hidden;
  }

  .aula-extra-toggle,
  .aula-extra-toggle-static {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: rgba(255,255,255,0.04);
    color: #fff;
    border: 0;
    font-size: 1rem;
    font-weight: 800;
    cursor: pointer;
  }

  .aula-extra-toggle {
    transition: background .18s ease;
  }

  .aula-extra-toggle:hover {
    background: rgba(255,255,255,0.06);
  }

  .aula-extra-toggle span:last-child {
    color: #ff7b7b;
    font-size: 1.6rem;
    line-height: 1;
    font-weight: 700;
  }

  .aula-extra-content {
    padding: 18px 20px 20px;
    background: rgba(255,255,255,0.02);
    border-top: 1px solid rgba(255,255,255,0.06);
  }

  .aula-extra-title {
    margin-top: 10px;
  }

  .aula-extra-text {
    margin-top: 14px;
    line-height: 1.7;
  }

  .exercise-image-card {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 18px;
    padding: 10px;
  }

  .exercise-image {
    width: 100%;
    border-radius: 14px;
    background: #0b0b0b;
    border: 1px solid rgba(255,255,255,0.06);
  }

  .exercise-image-label {
    display: block;
    margin-top: 8px;
    color: rgba(255,255,255,0.86);
    font-size: 0.88rem;
    font-weight: 700;
  }

  .upload-area,
  .uploaded-files-box {
    margin-top: 16px;
    padding: 16px;
    border-radius: 18px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
  }

  .upload-input-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 13px 16px;
    border-radius: 14px;
    background: linear-gradient(135deg, #ff5b5b 0%, #d93a3a 100%);
    border: 1px solid rgba(255,255,255,0.08);
    color: #fff;
    font-weight: 800;
    cursor: pointer;
    margin-bottom: 14px;
    box-shadow: 0 14px 40px rgba(255,91,91,0.20);
  }

  .upload-input {
    display: none;
  }

  .upload-selected-item,
  .uploaded-file-link {
    padding: 12px 14px;
    border-radius: 14px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
  }

  .upload-file-name,
  .upload-file-size,
  .uploaded-file-link {
    color: rgba(255,255,255,0.88);
  }

  .uploaded-file-link {
    display: block;
    text-decoration: none;
    transition: background .18s ease, border-color .18s ease, transform .18s ease;
  }

  .uploaded-file-link:hover {
    background: rgba(255,91,91,0.10);
    border-color: rgba(255,91,91,0.24);
    transform: translateY(-1px);
  }

  .teacher-admin-card {
    border: 1px solid rgba(255,91,91,0.28);
    box-shadow: 0 18px 60px rgba(255,91,91,0.10);
  }

  .teacher-admin-form {
    display: grid;
    gap: 14px;
    margin-top: 14px;
  }

  .teacher-admin-label {
    display: grid;
    gap: 8px;
    color: rgba(255,255,255,0.9);
    font-weight: 800;
  }

  .teacher-admin-input {
    width: 100%;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 14px;
    background: rgba(0,0,0,0.24);
    color: #fff;
    padding: 13px 14px;
    outline: 0;
    font-size: 0.95rem;
  }

  .teacher-admin-input:focus {
    border-color: rgba(255,91,91,0.48);
    box-shadow: 0 0 0 3px rgba(255,91,91,0.10);
  }

  .teacher-admin-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .teacher-upload-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
  }

  .teacher-upload-box {
    padding: 14px;
    border-radius: 18px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
  }

  @media (max-width: 768px) {
    .video-card.video-card-expanded {
      padding: 14px;
    }

    .aula-extra-toggle,
    .aula-extra-toggle-static {
      padding: 16px;
      font-size: 0.95rem;
    }

    .aula-extra-content {
      padding: 0 16px 16px;
    }
  }
`;

export default function AulaScreen({ aulaSlug, onBack, user }) {
  const aulaBase = useMemo(() => AULAS_CONFIG[aulaSlug], [aulaSlug]);
  const [remoteAulaData, setRemoteAulaData] = useState(null);

  const aula = useMemo(
    () => mergeLessonContent(aulaBase, remoteAulaData),
    [aulaBase, remoteAulaData]
  );

  const isProfessor = user?.email?.toLowerCase?.() === PROFESSOR_EMAIL;

  const [playerUnlocked, setPlayerUnlocked] = useState(false);
  const [abrirExercicios, setAbrirExercicios] = useState(false);
  const [abrirProva, setAbrirProva] = useState(false);

  const [exerciseImages, setExerciseImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);
  const [imagesError, setImagesError] = useState('');

  const [proofImages, setProofImages] = useState([]);
  const [loadingProofImages, setLoadingProofImages] = useState(false);
  const [proofImagesError, setProofImagesError] = useState('');

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadMessage, setUploadMessage] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingUploadedFiles, setLoadingUploadedFiles] = useState(false);

  const [videoLinkInput, setVideoLinkInput] = useState('');
  const [teacherMessage, setTeacherMessage] = useState('');
  const [teacherUploadingType, setTeacherUploadingType] = useState('');
  const [teacherUploadProgress, setTeacherUploadProgress] = useState(0);

  useEffect(() => {
    const styleId = 'ink-aula-screen-styles';
    let styleTag = document.getElementById(styleId);

    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.innerHTML = injectedStyles;
      document.head.appendChild(styleTag);
    }
  }, []);

  useEffect(() => {
    if (!aulaSlug) {
      setRemoteAulaData(null);
      return undefined;
    }

    const aulaRef = doc(db, 'aulas_conteudo', aulaSlug);

    const unsubscribe = onSnapshot(
      aulaRef,
      (snapshot) => {
        setRemoteAulaData(snapshot.exists() ? snapshot.data() : null);
      },
      (error) => {
        console.error('Erro ao carregar conteúdo dinâmico da aula:', error);
        setRemoteAulaData(null);
      }
    );

    return unsubscribe;
  }, [aulaSlug]);

  useEffect(() => {
    setPlayerUnlocked(isProfessor);
    setAbrirExercicios(false);
    setAbrirProva(false);

    setExerciseImages([]);
    setLoadingImages(false);
    setImagesError('');

    setProofImages([]);
    setLoadingProofImages(false);
    setProofImagesError('');

    setSelectedFiles([]);
    setUploadMessage('');
    setUploadProgress(0);
    setTeacherMessage('');
    setTeacherUploadingType('');
    setTeacherUploadProgress(0);
  }, [aulaSlug, isProfessor]);

  useEffect(() => {
    if (isProfessor) {
      setPlayerUnlocked(true);
    }
  }, [isProfessor]);

  useEffect(() => {
    setVideoLinkInput(aula?.vimeoEmbedUrl || '');
  }, [aula?.vimeoEmbedUrl]);

  useEffect(() => {
    const loadExerciseImages = async () => {
      if (!aula?.exercicios?.imagens?.length) {
        setExerciseImages([]);
        setImagesError('');
        return;
      }

      try {
        setLoadingImages(true);
        setImagesError('');

        const imageUrls = [];

        for (const imagePath of aula.exercicios.imagens) {
          try {
            const url = isHttpUrl(imagePath) ? imagePath : await getDownloadURL(ref(storage, imagePath));

            imageUrls.push({
              name: imagePath.split('/').pop() || imagePath,
              url,
            });
          } catch (error) {
            console.error(`Erro ao carregar imagem ${imagePath}:`, error);
            setImagesError(`Não foi possível carregar a imagem: ${imagePath}`);
          }
        }

        setExerciseImages(imageUrls);
      } catch (error) {
        console.error('Erro ao carregar imagens dos exercícios:', error);
        setImagesError('Não foi possível carregar as imagens de referência.');
        setExerciseImages([]);
      } finally {
        setLoadingImages(false);
      }
    };

    loadExerciseImages();
  }, [aula]);

  useEffect(() => {
    const loadProofImages = async () => {
      if (!aula?.prova?.imagens?.length) {
        setProofImages([]);
        setProofImagesError('');
        return;
      }

      try {
        setLoadingProofImages(true);
        setProofImagesError('');

        const imageUrls = [];

        for (const imagePath of aula.prova.imagens) {
          try {
            const url = isHttpUrl(imagePath) ? imagePath : await getDownloadURL(ref(storage, imagePath));

            imageUrls.push({
              name: imagePath.split('/').pop() || imagePath,
              url,
            });
          } catch (error) {
            console.error(`Erro ao carregar imagem da prova ${imagePath}:`, error);
            setProofImagesError(`Não foi possível carregar a imagem: ${imagePath}`);
          }
        }

        setProofImages(imageUrls);
      } catch (error) {
        console.error('Erro ao carregar imagens da prova:', error);
        setProofImagesError('Não foi possível carregar as imagens da prova.');
        setProofImages([]);
      } finally {
        setLoadingProofImages(false);
      }
    };

    loadProofImages();
  }, [aula]);

  useEffect(() => {
    const loadUploadedFiles = async () => {
      if (!user?.uid || !aulaSlug) {
        setUploadedFiles([]);
        return;
      }

      try {
        setLoadingUploadedFiles(true);

        const folderRef = ref(storage, `entregas/${user.uid}/${aulaSlug}`);
        const listResult = await listAll(folderRef);

        const files = await Promise.all(
          listResult.items.map(async (itemRef) => {
            const url = await getDownloadURL(itemRef);
            return {
              name: itemRef.name,
              url,
            };
          })
        );

        files.sort((a, b) => a.name.localeCompare(b.name));
        setUploadedFiles(files);
      } catch (error) {
        console.error('Erro ao listar arquivos enviados:', error);
        setUploadedFiles([]);
      } finally {
        setLoadingUploadedFiles(false);
      }
    };

    loadUploadedFiles();
  }, [user, aulaSlug]);

  const buildVimeoEmbedUrl = (baseUrl) => {
    if (!baseUrl) return '';

    if (baseUrl.includes('youtube.com/embed/') || baseUrl.includes('player.vimeo.com/video/')) {
      return baseUrl;
    }

    const youtubeMatch = baseUrl.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);

    if (youtubeMatch?.[1]) {
      return `https://www.youtube.com/embed/${youtubeMatch[1]}?rel=0`;
    }

    return baseUrl;
  };

  const sanitizeFileName = (fileName) => {
    return fileName.replace(/\s+/g, '_').replace(/[^\w.\-]/g, '');
  };

  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const handleFilesChange = async (event) => {
    const files = Array.from(event.target.files || []);
    setSelectedFiles(files);
    setUploadMessage('');

    if (files.length) {
      await handleUploadFiles(files);
    }

    event.target.value = '';
  };

  const handleUploadFiles = async (filesToUpload = selectedFiles) => {
    if (!user?.uid) {
      setUploadMessage('Usuário não identificado para envio.');
      return;
    }

    if (!aulaSlug) {
      setUploadMessage('Aula não identificada.');
      return;
    }

    if (!filesToUpload.length) {
      setUploadMessage('Selecione ao menos um arquivo para enviar.');
      return;
    }

    try {
      setUploadingFiles(true);
      setUploadMessage('');
      setUploadProgress(0);

      const totalFiles = filesToUpload.length;
      let uploadedCount = 0;

      for (const file of filesToUpload) {
        const safeName = sanitizeFileName(file.name);
        const storagePath = `entregas/${user.uid}/${aulaSlug}/${Date.now()}_${safeName}`;
        const fileRef = ref(storage, storagePath);

        await new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(fileRef, file);

          uploadTask.on(
            'state_changed',
            () => {},
            (error) => reject(error),
            () => resolve()
          );
        });

        uploadedCount += 1;
        setUploadProgress(Math.round((uploadedCount / totalFiles) * 100));
      }

      setUploadMessage('Arquivos enviados com sucesso.');
      setSelectedFiles([]);

      const folderRef = ref(storage, `entregas/${user.uid}/${aulaSlug}`);
      const listResult = await listAll(folderRef);

      const files = await Promise.all(
        listResult.items.map(async (itemRef) => {
          const url = await getDownloadURL(itemRef);
          return {
            name: itemRef.name,
            url,
          };
        })
      );

      files.sort((a, b) => a.name.localeCompare(b.name));
      setUploadedFiles(files);
    } catch (error) {
      console.error('Erro ao enviar arquivos:', error);
      setUploadMessage('Não foi possível enviar os arquivos.');
    } finally {
      setUploadingFiles(false);
    }
  };

  const handleSaveVideoLink = async () => {
    if (!isProfessor) {
      setTeacherMessage('Apenas o professor pode alterar o link da aula.');
      return;
    }

    if (!aulaSlug) {
      setTeacherMessage('Aula não identificada.');
      return;
    }

    try {
      const cleanedLink = videoLinkInput.trim();

      await setDoc(
        doc(db, 'aulas_conteudo', aulaSlug),
        {
          vimeoEmbedUrl: buildVimeoEmbedUrl(cleanedLink),
          videoOriginalUrl: cleanedLink,
          updatedAt: serverTimestamp(),
          updatedBy: user?.email || '',
        },
        { merge: true }
      );

      setTeacherMessage('Link do vídeo salvo com sucesso.');
      setPlayerUnlocked(isProfessor);
    } catch (error) {
      console.error('Erro ao salvar link do vídeo:', error);
      setTeacherMessage('Não foi possível salvar o link do vídeo.');
    }
  };

  const handleTeacherReferenceUpload = async (type, files) => {
    if (!isProfessor) {
      setTeacherMessage('Apenas o professor pode subir imagens de referência.');
      return;
    }

    if (!aulaSlug) {
      setTeacherMessage('Aula não identificada.');
      return;
    }

    const filesToUpload = Array.from(files || []);

    if (!filesToUpload.length) return;

    try {
      setTeacherUploadingType(type);
      setTeacherUploadProgress(0);
      setTeacherMessage('');

      const uploadedUrls = [];
      let uploadedCount = 0;

      for (const file of filesToUpload) {
        const safeName = sanitizeFileName(file.name);
        const storagePath = `conteudo_aulas/${aulaSlug}/${type}/${Date.now()}_${safeName}`;
        const fileRef = ref(storage, storagePath);

        await new Promise((resolve, reject) => {
          const uploadTask = uploadBytesResumable(fileRef, file);

          uploadTask.on(
            'state_changed',
            (snapshot) => {
              const currentFileProgress = snapshot.totalBytes
                ? snapshot.bytesTransferred / snapshot.totalBytes
                : 0;
              const totalProgress = Math.round(
                ((uploadedCount + currentFileProgress) / filesToUpload.length) * 100
              );
              setTeacherUploadProgress(totalProgress);
            },
            (error) => reject(error),
            async () => {
              const downloadUrl = await getDownloadURL(fileRef);
              uploadedUrls.push(downloadUrl);
              resolve();
            }
          );
        });

        uploadedCount += 1;
        setTeacherUploadProgress(Math.round((uploadedCount / filesToUpload.length) * 100));
      }

      const currentImages = remoteAulaData?.[type]?.imagens || [];

      await setDoc(
        doc(db, 'aulas_conteudo', aulaSlug),
        {
          [type]: {
            imagens: [...currentImages, ...uploadedUrls],
          },
          updatedAt: serverTimestamp(),
          updatedBy: user?.email || '',
        },
        { merge: true }
      );

      setTeacherMessage(
        type === 'exercicios'
          ? 'Imagem adicionada aos exercícios com sucesso.'
          : 'Imagem adicionada à prova com sucesso.'
      );
    } catch (error) {
      console.error('Erro ao subir imagem do professor:', error);
      setTeacherMessage('Não foi possível subir a imagem.');
    } finally {
      setTeacherUploadingType('');
      setTeacherUploadProgress(0);
    }
  };


  return (
    <div
      className="container2 home-shell"
      style={{
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden',
      }}
    >
      <div
        className="container home-container"
        style={{
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          boxSizing: 'border-box',
        }}
      >
        <div
          className="aula-screen-box"
          style={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            boxSizing: 'border-box',
            overflowX: 'hidden',
          }}
        >
          <div
            className="aula-screen-topbar"
            style={{
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
              boxSizing: 'border-box',
            }}
          >
            <button type="button" className="btn btn-outline" onClick={onBack}>
              Voltar
            </button>
          </div>

          <div
            className="video-card video-card-expanded"
            style={{
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
              boxSizing: 'border-box',
              overflow: 'hidden',
            }}
          >
            {!aula ? (
              <div className="video-placeholder">Aula não encontrada.</div>
            ) : !aula.vimeoEmbedUrl ? (
              <div className="video-placeholder">Vídeo ainda não configurado para esta aula.</div>
            ) : (
              <div
                className="vimeo-embed-wrap vimeo-embed-wrap-tall"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                }}
              >
                {!playerUnlocked && !isProfessor && (
                  <div className="video-protect-overlay">
                    <div className="video-protect-box">
                      <div className="video-protect-badge">AULA PROTEGIDA</div>
                      <h3 className="video-protect-title">{aula.titulo}</h3>
                      <p className="video-protect-text">
                        Clique abaixo para liberar o player desta aula.
                      </p>

                      <button
                        type="button"
                        className="btn btn-primary video-protect-btn"
                        onClick={() => setPlayerUnlocked(true)}
                      >
                        Assistir aula
                      </button>
                    </div>
                  </div>
                )}

                <iframe
                  className={`lesson-iframe ${!playerUnlocked && !isProfessor ? 'lesson-iframe-locked' : ''}`}
                  src={buildVimeoEmbedUrl(aula.vimeoEmbedUrl)}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  title={aula.titulo || 'Aula'}
                  allowFullScreen
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    display: 'block',
                  }}
                />
              </div>
            )}
          </div>

          {aula && (
            <div
              className="aula-extra-sections"
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: 16,
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
              }}
            >
              {isProfessor && (
                <div
                  className="aula-extra-card teacher-admin-card"
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    className="aula-extra-toggle aula-extra-toggle-static"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <span>Área do professor</span>
                  </div>

                  <div
                    className="aula-extra-content"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <h3 className="aula-extra-title">Editar conteúdo desta aula</h3>
                    <p className="aula-extra-text">
                      Use essa área para trocar o link do vídeo e subir imagens de exercício
                      ou prova sem mexer no código.
                    </p>

                    <div className="teacher-admin-form">
                      <label className="teacher-admin-label" htmlFor="teacher-video-link">
                        Link do vídeo
                        <input
                          id="teacher-video-link"
                          type="url"
                          className="teacher-admin-input"
                          placeholder="Cole aqui o link do YouTube"
                          value={videoLinkInput}
                          onChange={(event) => setVideoLinkInput(event.target.value)}
                        />
                      </label>

                      <div className="teacher-admin-actions">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSaveVideoLink}
                        >
                          Salvar link do vídeo
                        </button>
                      </div>

                      <div className="teacher-upload-grid">
                        <div className="teacher-upload-box">
                          <h4 className="uploaded-files-title">Imagem de exercício</h4>
                          <p className="aula-extra-helper">
                            Suba uma ou mais imagens para aparecerem na área de exercícios.
                          </p>

                          <label className="upload-input-label" htmlFor="teacher-exercise-upload">
                            {teacherUploadingType === 'exercicios'
                              ? `Enviando... ${teacherUploadProgress}%`
                              : 'Subir imagem do exercício'}
                          </label>
                          <input
                            id="teacher-exercise-upload"
                            type="file"
                            accept="image/*"
                            multiple
                            className="upload-input"
                            disabled={!!teacherUploadingType}
                            onChange={(event) => {
                              handleTeacherReferenceUpload('exercicios', event.target.files);
                              event.target.value = '';
                            }}
                          />
                        </div>

                        <div className="teacher-upload-box">
                          <h4 className="uploaded-files-title">Imagem de prova</h4>
                          <p className="aula-extra-helper">
                            Suba uma ou mais imagens para aparecerem na área de prova.
                          </p>

                          <label className="upload-input-label" htmlFor="teacher-proof-upload">
                            {teacherUploadingType === 'prova'
                              ? `Enviando... ${teacherUploadProgress}%`
                              : 'Subir imagem da prova'}
                          </label>
                          <input
                            id="teacher-proof-upload"
                            type="file"
                            accept="image/*"
                            multiple
                            className="upload-input"
                            disabled={!!teacherUploadingType}
                            onChange={(event) => {
                              handleTeacherReferenceUpload('prova', event.target.files);
                              event.target.value = '';
                            }}
                          />
                        </div>
                      </div>

                      {teacherMessage && <p className="upload-message">{teacherMessage}</p>}
                    </div>
                  </div>
                </div>
              )}

              <div
                className="aula-extra-card"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                }}
              >
                <button
                  type="button"
                  className="aula-extra-toggle"
                  onClick={() => setAbrirExercicios((prev) => !prev)}
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                  }}
                >
                  <span>Exercícios</span>
                  <span>{abrirExercicios ? '−' : '+'}</span>
                </button>

                {abrirExercicios && (
                  <div
                    className="aula-extra-content"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <h3 className="aula-extra-title">{aula.exercicios?.titulo}</h3>
                    <p
                      className="aula-extra-text"
                      style={{
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {aula.exercicios?.descricao}
                    </p>

                    {loadingImages ? (
                      <p className="aula-extra-helper">Carregando referências...</p>
                    ) : imagesError ? (
                      <p className="aula-extra-helper">{imagesError}</p>
                    ) : exerciseImages.length > 0 ? (
                      <div
                        className="exercise-images-grid"
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                          gap: 14,
                          width: '100%',
                          maxWidth: '100%',
                          minWidth: 0,
                          boxSizing: 'border-box',
                        }}
                      >
                        {exerciseImages.map((image, index) => (
                          <div
                            key={image.name}
                            className="exercise-image-card"
                            style={{
                              width: '100%',
                              maxWidth: '100%',
                              minWidth: 0,
                              boxSizing: 'border-box',
                              overflow: 'hidden',
                            }}
                          >
                            <img
                              src={image.url}
                              alt={`Referência ${index + 1}`}
                              className="exercise-image"
                              style={{
                                width: '100%',
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                              }}
                            />
                            <span className="exercise-image-label">
                              Referência {index + 1}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="aula-extra-helper">
                        Nenhuma imagem foi encontrada no Storage.
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div
                className="aula-extra-card"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                }}
              >
                <button
                  type="button"
                  className="aula-extra-toggle"
                  onClick={() => setAbrirProva((prev) => !prev)}
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                  }}
                >
                  <span>Prova</span>
                  <span>{abrirProva ? '−' : '+'}</span>
                </button>

                {abrirProva && (
                  <div
                    className="aula-extra-content"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <h3 className="aula-extra-title">{aula.prova?.titulo}</h3>

                    {aula.prova?.descricao ? (
                      <p
                        className="aula-extra-text"
                        style={{
                          whiteSpace: 'pre-wrap',
                          overflowWrap: 'anywhere',
                        }}
                      >
                        {aula.prova.descricao}
                      </p>
                    ) : null}

                    {loadingProofImages ? (
                      <p className="aula-extra-helper">Carregando imagem da prova...</p>
                    ) : proofImagesError ? (
                      <p className="aula-extra-helper">{proofImagesError}</p>
                    ) : proofImages.length > 0 ? (
                      <div
                        className="exercise-images-grid"
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                          gap: 14,
                          width: '100%',
                          maxWidth: '100%',
                          minWidth: 0,
                          boxSizing: 'border-box',
                        }}
                      >
                        {proofImages.map((image, index) => (
                          <div
                            key={image.name}
                            className="exercise-image-card"
                            style={{
                              width: '100%',
                              maxWidth: '100%',
                              minWidth: 0,
                              boxSizing: 'border-box',
                              overflow: 'hidden',
                            }}
                          >
                            <img
                              src={image.url}
                              alt={`Imagem da prova ${index + 1}`}
                              className="exercise-image"
                              style={{
                                width: '100%',
                                maxWidth: '100%',
                                height: 'auto',
                                display: 'block',
                              }}
                            />
                            <span className="exercise-image-label">
                              Prova {index + 1}
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="aula-extra-helper">
                        Nenhuma imagem da prova foi encontrada no Storage.
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div
                className="aula-extra-card"
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0,
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                }}
              >
                <div
                  className="aula-extra-toggle aula-extra-toggle-static"
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                  }}
                >
                  <span>Upload dos arquivos da aula</span>
                </div>

                <div
                  className="aula-extra-content"
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box',
                  }}
                >
                  <h3 className="aula-extra-title">Envio da atividade</h3>
                  <p
                    className="aula-extra-text"
                    style={{
                      overflowWrap: 'anywhere',
                    }}
                  >
                    Envie aqui os arquivos referentes a esta aula. Você pode mandar imagens,
                    PDFs e outros arquivos do seu estudo.
                  </p>

                  <div
                    className="upload-area"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <label className="upload-input-label" htmlFor="lesson-file-upload">
                      {uploadingFiles ? `Enviando... ${uploadProgress}%` : 'Selecionar e enviar arquivos'}
                    </label>

                    <input
                      id="lesson-file-upload"
                      type="file"
                      multiple
                      className="upload-input"
                      onChange={handleFilesChange}
                      disabled={uploadingFiles}
                    />

                    {selectedFiles.length > 0 && (
                      <div
                        className="upload-selected-list"
                        style={{
                          display: 'grid',
                          gap: 8,
                          width: '100%',
                          maxWidth: '100%',
                          minWidth: 0,
                        }}
                      >
                        {selectedFiles.map((file) => (
                          <div
                            key={`${file.name}-${file.size}`}
                            className="upload-selected-item"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 10,
                              flexWrap: 'wrap',
                              width: '100%',
                              minWidth: 0,
                            }}
                          >
                            <span
                              className="upload-file-name"
                              style={{
                                minWidth: 0,
                                overflowWrap: 'anywhere',
                                wordBreak: 'break-word',
                              }}
                            >
                              {file.name}
                            </span>
                            <span className="upload-file-size">{formatFileSize(file.size)}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {uploadMessage && <p className="upload-message">{uploadMessage}</p>}
                  </div>

                  <div
                    className="uploaded-files-box"
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: 0,
                      boxSizing: 'border-box',
                    }}
                  >
                    <h4 className="uploaded-files-title">Arquivos já enviados</h4>

                    {loadingUploadedFiles ? (
                      <p className="aula-extra-helper">Carregando arquivos enviados...</p>
                    ) : uploadedFiles.length > 0 ? (
                      <div
                        className="uploaded-files-list"
                        style={{
                          display: 'grid',
                          gap: 10,
                          width: '100%',
                          maxWidth: '100%',
                          minWidth: 0,
                        }}
                      >
                        {uploadedFiles.map((file) => (
                          <a
                            key={file.name}
                            href={file.url}
                            target="_blank"
                            rel="noreferrer"
                            className="uploaded-file-link"
                            style={{
                              minWidth: 0,
                              overflowWrap: 'anywhere',
                              wordBreak: 'break-word',
                            }}
                          >
                            {file.name}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <p className="aula-extra-helper">
                        Nenhum arquivo enviado para esta aula ainda.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}